(function () {
    const header = document.querySelector('[data-header-2026]');
    if (!header) return;

    const CLOSED_CLASSES = ['-translate-y-full', 'opacity-0', 'pointer-events-none'];
    const SCROLL_TOLERANCE = 4;

    const triggers = header.querySelectorAll('[data-menu]');
    const mobileToggle = header.querySelector('[data-mobile-toggle]');
    // The mobile menu is a sibling of the header, not a child — the header's transform
    // would otherwise become the containing block for its position:fixed panel.
    const mobileMenu = document.querySelector('[data-mobile-menu]');
    const mobileClose = mobileMenu ? mobileMenu.querySelector('[data-mobile-close]') : null;
    const mobileLevel1 = mobileMenu ? mobileMenu.querySelector('[data-mobile-level-1]') : null;
    const mobileDrillTriggers = document.querySelectorAll('[data-mobile-drill]');
    const mobileBackButtons = document.querySelectorAll('[data-mobile-back]');
    const mobilePanels = document.querySelectorAll('[data-mobile-panel]');

    let active = null;
    let scrollBaseline = null;
    let activeMobilePanel = null;

    const getPanel = (name) => header.querySelector(`[data-megamenu="${CSS.escape(name)}"]`);
    const getMobilePanel = (id) => document.querySelector(`[data-mobile-panel="${CSS.escape(id)}"]`);

    const openPanel = (panel, trigger) => {
        panel.classList.remove(...CLOSED_CLASSES);
        trigger.setAttribute('aria-expanded', 'true');
        const chevron = trigger.querySelector('[data-chevron]');
        if (chevron) chevron.classList.add('rotate-180');
        active = { panel, trigger };
        scrollBaseline = window.scrollY;
    };

    const closePanel = () => {
        if (!active) return;
        const { panel, trigger } = active;
        panel.classList.add(...CLOSED_CLASSES);
        trigger.setAttribute('aria-expanded', 'false');
        const chevron = trigger.querySelector('[data-chevron]');
        if (chevron) chevron.classList.remove('rotate-180');
        active = null;
        scrollBaseline = null;
    };

    triggers.forEach((trigger) => {
        const panel = getPanel(trigger.dataset.menu);
        if (!panel) return; // No megamenu wired for this trigger yet.

        trigger.setAttribute('aria-haspopup', 'true');
        trigger.setAttribute('aria-expanded', 'false');

        trigger.addEventListener('click', (e) => {
            e.stopPropagation();
            const isSame = active && active.panel === panel;
            closePanel();
            if (!isSame) openPanel(panel, trigger);
        });
    });

    // ---------- Hide-on-scroll-down / show-on-scroll-up ----------
    const HIDE_CLASS = '-translate-y-full';
    const HIDE_AFTER = 80; // px from top before we start hiding
    const DIRECTION_TOLERANCE = 6; // px of movement before we react
    let lastScrollY = window.scrollY;
    let hideTicking = false;

    const isMobileMenuOpen = () => mobileMenu && !mobileMenu.classList.contains('translate-x-full');

    const updateHeaderVisibility = () => {
        hideTicking = false;
        const currentY = window.scrollY;
        const delta = currentY - lastScrollY;

        if (Math.abs(delta) < DIRECTION_TOLERANCE) return;

        // Always show near the top, or when a panel/mobile menu is open.
        if (currentY <= HIDE_AFTER || active || isMobileMenuOpen()) {
            header.classList.remove(HIDE_CLASS);
        } else if (delta > 0) {
            header.classList.add(HIDE_CLASS);
        } else {
            header.classList.remove(HIDE_CLASS);
        }

        lastScrollY = currentY;
    };

    window.addEventListener('scroll', () => {
        if (active && scrollBaseline !== null && Math.abs(window.scrollY - scrollBaseline) > SCROLL_TOLERANCE) {
            closePanel();
        }
        if (!hideTicking) {
            window.requestAnimationFrame(updateHeaderVisibility);
            hideTicking = true;
        }
    }, { passive: true });

    document.addEventListener('click', (e) => {
        if (!active) return;
        if (header.contains(e.target)) return;
        closePanel();
    });

    // ---------- Search overlay ----------
    const searchToggles = document.querySelectorAll('[data-search-toggle]');
    const searchOverlay = document.querySelector('#search-overlay');
    const searchClose = searchOverlay ? searchOverlay.querySelector('.search-overlay__close') : null;
    const searchInput = searchOverlay ? searchOverlay.querySelector('#global-search') : null;

    const isSearchOpen = () => document.body.classList.contains('search-open');

    const openSearch = () => {
        // Close any other open header UI first.
        closePanel();
        if (mobileMenu && !mobileMenu.classList.contains('translate-x-full')) closeMobileMenu();
        document.body.classList.add('search-open');
        searchToggles.forEach((b) => b.setAttribute('aria-expanded', 'true'));
        if (searchInput) {
            // Delay focus so it lands after the overlay's reveal transition.
            window.setTimeout(() => {
                searchInput.value = '';
                searchInput.focus();
            }, 500);
        }
    };

    const closeSearch = () => {
        document.body.classList.remove('search-open');
        searchToggles.forEach((b) => b.setAttribute('aria-expanded', 'false'));
    };

    if (searchOverlay && searchToggles.length) {
        searchToggles.forEach((btn) => {
            btn.setAttribute('aria-haspopup', 'dialog');
            btn.setAttribute('aria-expanded', 'false');
            btn.addEventListener('click', () => {
                if (isSearchOpen()) closeSearch();
                else openSearch();
            });
        });
        if (searchClose) searchClose.addEventListener('click', closeSearch);
    }

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            closePanel();
            if (mobileMenu && !mobileMenu.classList.contains('translate-x-full')) closeMobileMenu();
            if (isSearchOpen()) closeSearch();
        }
    });

    // ---------- Mobile menu ----------
    if (!mobileMenu || !mobileToggle) return;

    const openMobileMenu = () => {
        mobileMenu.classList.remove('translate-x-full');
        mobileMenu.setAttribute('aria-hidden', 'false');
        mobileToggle.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
    };

    const resetMobilePanels = () => {
        mobilePanels.forEach((p) => p.classList.add('translate-x-full'));
        if (mobileLevel1) mobileLevel1.classList.remove('-translate-x-full');
        activeMobilePanel = null;
    };

    const closeMobileMenu = () => {
        mobileMenu.classList.add('translate-x-full');
        mobileMenu.setAttribute('aria-hidden', 'true');
        mobileToggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        // Reset inner panels after the slide-out completes.
        window.setTimeout(resetMobilePanels, 300);
    };

    const drillInto = (id) => {
        const panel = getMobilePanel(id);
        if (!panel) return;
        if (mobileLevel1) mobileLevel1.classList.add('-translate-x-full');
        panel.classList.remove('translate-x-full');
        activeMobilePanel = panel;
    };

    const drillBack = () => {
        if (!activeMobilePanel) return;
        activeMobilePanel.classList.add('translate-x-full');
        if (mobileLevel1) mobileLevel1.classList.remove('-translate-x-full');
        activeMobilePanel = null;
    };

    mobileToggle.setAttribute('aria-expanded', 'false');
    mobileToggle.setAttribute('aria-controls', 'mobile-menu');
    mobileToggle.addEventListener('click', () => {
        const isOpen = !mobileMenu.classList.contains('translate-x-full');
        if (isOpen) closeMobileMenu();
        else openMobileMenu();
    });

    if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);

    mobileDrillTriggers.forEach((btn) => {
        btn.addEventListener('click', () => drillInto(btn.dataset.mobileDrill));
    });

    mobileBackButtons.forEach((btn) => {
        btn.addEventListener('click', drillBack);
    });
}());
